import { FC } from 'react';
import Stack, { StackProps } from '@mui/material/Stack';

interface RowProps extends StackProps {}

const Row: FC<RowProps> = (props) => {
    return <Stack direction="row" gap={2} width="100%" {...props} />;
};

export type { RowProps };
export default Row;
